export enum FP_URLS {
  BASE = 'fund-performances',
  FUND = 'fund',
  VALUE_CREATION = 'value-creation',
}

export enum FP_URLS_FULL_PATH {
  BASE = FP_URLS.BASE,
  FUND = FP_URLS.BASE + '/' + FP_URLS.FUND,
}
